import type { ClickData, ViewData } from '@/types/index.mts';

const siteId = 'post purchase';

const isMetricsInitialized = () => {
  if (window && window.metrics) {
    return true;
  }
  return false;
};

/*
  Use this to set up any click links to all anchor and button tags
  The link event will fire on click with the data-analytics-id attribute.
  For more info https://git.rei.com/projects/FEDPACK/repos/rei-metrics/browse#basic-usage
*/
export const setupAnalyticsClicks = () => {
  if (isMetricsInitialized()) {
    window.metrics.addClickListenersFromSelector();
  }
};

/*
  Use this method only if there are instances of clicks/hover that need to be
  custom and will not be covered by the setupAnalyticsClicks method.
  Expects the above type as input (ClickData).
*/
export const recordClick = (data: ClickData) => {
  if (isMetricsInitialized()) {
    window.metrics.link(data);
  }
};

/*
  Expects the above type as input (ViewData).
  Should be called on mount of a page view in most cases.
*/
export const recordView = (data: ViewData) => {
  const pageName = `post purchase:${data.templateType}_${data.pageDescription}`;
  const viewData = {
    siteId,
    pageName,
    ...data,
  };
  if (isMetricsInitialized()) {
    window.metrics.view(viewData);
  }
};
